"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const material_1 = require("@angular/material");
const _4d_mapper_1 = require("4d-mapper");
const event_listener_interface_1 = require("@src/app/xs/interfaces/event-listener.interface");
const identify_interface_1 = require("@src/app/xs/interfaces/identify.interface");
const application_events_service_1 = require("@src/app/xs/services/events/application-events.service");
const map_viewer_service_1 = require("@src/app/service/map-viewer.service");
const Cesium = window['Cesium'];
class AlignBoundsComponent {
    constructor(fourd, applicationEvents, cesiumMapService) {
        this.fourd = fourd;
        this.applicationEvents = applicationEvents;
        this.cesiumMapService = cesiumMapService;
        this.__ID = null;
        this.__EVENTS = null;
        this.dataset = null;
        this.viewer = null;
        this.loading = true;
        this.__ID = identify_interface_1.XsIdentityInterface.__init(this);
        this.__EVENTS = event_listener_interface_1.XsEventListenerInterface.__init(this);
        console.log('## construct');
    }
    // ___mapViewer ( incoming:any = null ) {
    //     this.viewer = incoming.viewer;
    // }
    ngOnChanges() {
        // console.log('## changes', this.dataset);
    }
    ngAfterViewInit() {
        // console.log('## init');
        this.viewer = this.cesiumMapService.getMap('align').viewer;
        if (!this.dataset.initParams)
            this.dataset.initParams = {};
        if (this.dataset.crs)
            this.changed();
    }
    plot(d) {
        // console.log('## plot',d);
        if (this.plotted)
            this.viewer.entities.remove(this.plotted);
        var train = [];
        if (d instanceof _4d_mapper_1.Dataset) {
            train = [
                d['llng'], d['llat'],
                d['llng'], d['ulat'],
                d['ulng'], d['ulat'],
                d['ulng'], d['llat']
            ];
        }
        else {
            train = [
                d['minX'], d['minY'],
                d['minX'], d['maxY'],
                d['maxX'], d['maxY'],
                d['maxX'], d['minY']
            ];
        }
        this.plotted = this.viewer.entities.add({
            polygon: {
                hierarchy: Cesium.Cartesian3.fromDegreesArray(train),
                material: Cesium.Color.ORANGE.withAlpha(0.5),
                outline: true,
                outlineColor: Cesium.Color.YELLOW
            }
        });
        this.viewer.camera.flyTo({
            destination: Cesium.Rectangle.fromDegrees(train[0], train[1], train[4], train[5])
        });
    }
    changed() {
        // console.log('## changed');
        var e = this.dataset.initParams.easting || 0;
        var n = this.dataset.initParams.northing || 0;
        var h = this.dataset.initParams.height || 0;
        var bbox = this.dataset['unalignedBounds'];
        var newBox = {
            minX: e + bbox.minX,
            maxX: e + bbox.maxX,
            minY: n + bbox.minY,
            maxY: n + bbox.maxY,
            minZ: bbox.minZ,
            maxZ: bbox.maxZ
        };
        if (this.dataset.crs && this.dataset.crs.uid) {
            this.loading = true;
            this.fourd.V.api('/epsg/' + this.dataset.crs.uid, 'post', { bounds: newBox }).subscribe(s => {
                this.plot(s);
                this.dataset.initParams.crs_code = this.dataset.crs.uid;
                this.loading = false;
            }, e => {
                this.loading = false;
                alert(e.message);
            });
        }
    }
}
exports.AlignBoundsComponent = AlignBoundsComponent;
class AlignBoundsDialog {
    constructor(dialogRef, data, fourD) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.fourD = fourD;
        if (data.dataset && data.dataset.crs && !data.dataset.crs.uid) {
            this.fourD.V.searchByObject(_4d_mapper_1.EPSGCodes).equals("id", data.dataset.crs.id).queryObservable().subscribe(s => {
                data.dataset.crs = s.items[0];
                this.dataset = data.dataset;
            });
        }
        else {
            this.dataset = data.dataset;
        }
    }
    save() {
        this.dataset.saveObservable().subscribe(s => this.dialogRef.close(true));
    }
    cancel() {
        this.dialogRef.close(false);
    }
}
exports.AlignBoundsDialog = AlignBoundsDialog;
